import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { CreditCardAuthenticationPage } from 'src/app/model/page/group/api-docs/credit-card-authentication-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-credit-card-authentication-page',
  templateUrl: './credit-card-authentication-page.component.html',
  styleUrls: ['./credit-card-authentication-page.component.scss']
})
export class CreditCardAuthenticationPageComponent implements OnInit {
  creditCardAuthenticationPage: CreditCardAuthenticationPage = {} as CreditCardAuthenticationPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'credit-card-authentication') {
        this.creditCardAuthenticationPage.htmlTitle = title.htmlTitle;
      }
    });
    this.creditCardAuthenticationPage.sections = [];
    this.creditCardAuthenticationPage.tableSections = [];

    const query = { 'fields.title': 'Credit Card Authentication' };
    this.contentfulService.getPageContentResponse(query).then((CreditCardAuthenticationPageEntries) => {
      this.mapBanner(CreditCardAuthenticationPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.creditCardAuthenticationPage.banner);
      this.mapSections(CreditCardAuthenticationPageEntries.includes.Entry);
      this.mapTableSection(CreditCardAuthenticationPageEntries.includes.Entry);
      this.mapPageInfo(CreditCardAuthenticationPageEntries.items);
    });
  }

  private mapBanner(creditCardAuthenticationPageEntries: Entry<any>[]) {
    creditCardAuthenticationPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.creditCardAuthenticationPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }

  private mapSections(creditCardAuthenticationPageEntries: Entry<any>[]) {
    creditCardAuthenticationPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.creditCardAuthenticationPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();
    this.creditCardAuthenticationPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapTableSection(creditCardAuthenticationPageEntries: Entry<any>[]) {
    creditCardAuthenticationPageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
      });
    this.creditCardAuthenticationPage.tableSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToTableSection(entry: Entry<any>) {
    
let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#')[2];
    this.creditCardAuthenticationPage.tableSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      table: entry.fields['table'] as string,
      heading: entry.fields['heading'] as string
    });
    this.creditCardAuthenticationPage.tableSections.sort((a, b) => a.order - b.order);
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.creditCardAuthenticationPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.creditCardAuthenticationPage.banner.url = entry.fields?.url;
      this.creditCardAuthenticationPage.banner.editorEmail = editorDetails?.pop();
      this.creditCardAuthenticationPage.banner.editorShortName = editorDetails?.pop();
      this.creditCardAuthenticationPage.banner.editorFullName = editorDetails?.pop();
      this.creditCardAuthenticationPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
}
